var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75027 8C3.65527 8 3.5662 7.98497 3.48308 7.9549C3.39995 7.92531 3.32277 7.87472 3.25151 7.80313L0.187746 4.72483C0.0571203 4.59359 -0.00534254 4.42344 0.000357493 4.21441C0.00653253 4.00585 0.0749327 3.83594 0.205558 3.7047C0.336184 3.57345 0.502436 3.50783 0.704312 3.50783C0.906188 3.50783 1.07244 3.57345 1.20306 3.7047L3.75027 6.26398L9.78874 0.196868C9.91937 0.0656227 10.0887 0 10.2968 0C10.5043 0 10.6734 0.0656227 10.8041 0.196868C10.9347 0.328113 11 0.498016 11 0.706577C11 0.915615 10.9347 1.08576 10.8041 1.217L4.24902 7.80313C4.17777 7.87472 4.10058 7.92531 4.01746 7.9549C3.93433 7.98497 3.84527 8 3.75027 8Z",
    fill: "#89C6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.f14841bff3658d1cc8ac9349a1d26630.svg";
export { ForwardRef as ReactComponent };